import { getColorScheme } from "@appally/lib/utils/colorSchemes";
import { sliderAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(sliderAnatomy.keys);

const baseStyle = definePartsStyle({
  track: {
    rounded: "full",
  },
  mark: {
    pointerEvents: "auto!important",
  },
});

const solid = definePartsStyle((props) => {
  const { main, tint, text } = getColorScheme(props.colorScheme);
  return {
    track: {
      height: 3,
      bg: "gray.100",
      _dark: {
        bg: "gray.950",
      },
    },
    filledTrack: {
      bg: main,
    },
    thumb: {
      bg: main,
      boxSize: "12px",
    },
  };
});

const gradient = definePartsStyle((props) => {
  const { main, tint, text } = getColorScheme(props.colorScheme);
  return {
    track: {
      height: 3,
      bg: "gray.100",
    },
    filledTrack: {
      bgGradient: `linear(to-r, ${main}, ${tint}, yellow.500)`,
    },
    thumb: {
      bg: "yellow.500",
      boxSize: "24px",
      marginLeft: "-6px",
    },
  };
});

const progress = definePartsStyle((props) => {
  const { main, tint, light } = getColorScheme(props.colorScheme);
  return {
    track: {
      height: 3,
      bg: "gray.200",
    },
    filledTrack: {
      height: 4,
      bgGradient: `linear(to-r, ${light}, ${main})`,
    },
    thumb: {
      bg: main,
      boxSize: "24px",
      marginLeft: "-6px",
      p: 2,
    },
  };
});

export const Slider = defineMultiStyleConfig({
  variants: { solid, gradient, progress },
  baseStyle,
  defaultProps: {
    variant: "solid",
    colorScheme: "primary",
  },
});
